import { getAppointments, reserveAppointment } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const AppointmentDetailsAction = {
    GET_APPOINTMENTS_SUCCESS: 'GET_APPOINTMENTS_SUCCESS',
    GET_APPOINTMENTS_FAILURE: 'GET_APPOINTMENTS_FAILURE',
    RESERVE_APPOINTMENT_SUCCESS: 'RESERVE_APPOINTMENT_SUCCESS',
    RESERVE_APPOINTMENT_FAILURE: 'RESERVE_APPOINTMENT_FAILURE',
    SKIP_APPOINTMENT_SUCCESS: 'SKIP_APPOINTMENT_SUCCESS',
    SKIP_APPOINTMENT_FAILURE: 'SKIP_APPOINTMENT_FAILURE',
}

const getAppointmentsSlots = (odb: string, startDate: string, endDate: string, provider: any, typeOfService: any, bandWidth: any, city: any, district: any, region: any) => {
    return function (dispatch: any) {
        getAppointments(odb, startDate, endDate, provider, typeOfService, bandWidth, city, district, region)
            .then((response) => {
                dispatch({ type: AppointmentDetailsAction.GET_APPOINTMENTS_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const serviceName = provider.toLowerCase() !== 'mobily' ? 'getNonMobilyFTTHAppointments' : 'getMobilyFTTHAppointments';
                const config = Object.assign(err?.config, { serviceName: serviceName });
                const error = { ...err, config }

                if (error?.response) {
                    dispatch({ type: AppointmentDetailsAction.GET_APPOINTMENTS_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const reserveAppointmentSlot = (odb: string, slot: any, selectedDate: string, provider: string) => {
    return function (dispatch: any) {
        reserveAppointment(odb, slot.id, provider, slot.start, slot.end).then((response) => {
            dispatch({ type: AppointmentDetailsAction.RESERVE_APPOINTMENT_SUCCESS, payload: { selectedDate: selectedDate, appointmentStart: slot.start, appointmentEnd: slot.end, slotId: slot.id, provider: provider, response: response } });
            dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['AppointmentDetails'] });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const skipAppointment = () => {
    return function (dispatch: any) {
        dispatch({ type: AppointmentDetailsAction.SKIP_APPOINTMENT_SUCCESS });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['AppointmentDetails'] });
    }
}

export { AppointmentDetailsAction, getAppointmentsSlots, reserveAppointmentSlot, skipAppointment };